import Preview from './preview'

export default Preview
